const cart = {
  state: {
    beers: [],
    note: ''
  },
  mutations: {
    ADD_BEER: (state, beer) => {
      state.beers.push(beer)
    },
    SET_BEER: (state, beer) => {
      state.beers = beer
    },
    CLEAN_BEER: (state) => {
      state.beers = []
    },
    SET_NOTE: (state, note) => {
      state.note = note
    },
    CLEAN_NOTE: (state) => {
      state.note = ''
    }
  },
  actions: {
    SetNote ({ commit, state }, note) {
      commit('SET_NOTE', note)
    },
    ClearNote ({ commit, state }) {
      commit('CLEAN_NOTE')
    },
    LoadBeer ({ commit, state }, beer) {
      commit('SET_BEER', beer)
    },
    AddBeer ({ commit, state }, beer) {
      let arr = state.beers
      let found = false
      arr.forEach((item) => {
        console.log('item', item)
        if (item.beer.id === beer.beer.id && beer.beer.stocks.branches_id === item.beer.stocks.branches_id) {
          item.quantity += beer.quantity
          if (item.quantity > beer.beer.stocks.qty) {
            item.quantity = beer.beer.stocks.qty
          }
          found = true
        }
      })
      if (found) {
        commit('SET_BEER', arr)
      } else {
        commit('ADD_BEER', beer)
      }
    },
    UpdateBeer ({ commit, state }, beer) {
      let arr = state.beers
      let found = false
      arr.forEach((item) => {
        if (item.beer.id === beer.beer.id && beer.beer.stocks.branches_id === item.beer.stocks.branches_id) {
          item.quantity = beer.quantity
          if (item.quantity > beer.beer.stocks.qty) {
            item.quantity = beer.beer.stocks.qty
          }
          found = true
        }
      })
      if (found) {
        commit('SET_BEER', arr)
      }
    },
    CleanBeer ({ commit }) {
      commit('CLEAN_BEER')
    },
    RemoveBeer ({ commit, state }, beer) {
      let arr = state.beers.filter(item => beer !== item)
      commit('SET_BEER', arr)
    }
  }
}

export default cart



// WEBPACK FOOTER //
// ./src/store/modules/cart.js